<template>
    <template v-if="IsMobile">
        <div class="phone-body" v-if="aiOrderStore.show">
            <CloseFabButtonComponent @OnClose="aiOrderStore.show = false"></CloseFabButtonComponent>
            <div class="pc-card" :title="$t('components.AIOrderTaskWindow.title')">
                <div class="pc-ai-order-body">
                    <var-tabs style="height: 50px; min-height: 50px;" v-model:active="aiOrderStore.active">
                        <var-tab v-for="v in aiOrderStore.effectStatusArr" :key="v">
                            {{ $t(`components.AIOrderTaskWindow.${v}`) }}
                        </var-tab>
                    </var-tabs>

                    <template v-if="aiOrderStore.data.total > 0">
                        <div class="pc-ai-order-list">
                            <VarSpace direction="column" v-for="(v, i) in aiOrderStore.data.list" :key="v.Id">
                                <var-divider />
                                <VarSpace>
                                    <VarSpace>
                                        <VarSpace>{{ $t('components.AIOrderTaskWindow.rwd') }}</VarSpace>
                                        <VarSpace>
                                            <VarEllipsis class="order-number">
                                                {{ v.OrderNumber }}
                                            </VarEllipsis>
                                        </VarSpace>
                                    </VarSpace>

                                    <VarSpace>
                                        <VarSpace>{{ $t('components.AIOrderTaskWindow.cp') }}</VarSpace>
                                        <VarSpace>{{ v.Product.Dn }}</VarSpace>
                                    </VarSpace>

                                </VarSpace>

                                <VarSpace justify="space-between" align="center">
                                    <VarSpace>
                                        <VarSpace>{{ $t('components.AIOrderTaskWindow.gmfy') }}</VarSpace>
                                        <VarChip size="small" type="info">
                                            $ {{ Tools.TruncateDecimal(v.BuyCost ?? 0, 2) }}
                                        </VarChip>

                                    </VarSpace>

                                    <VarSpace align="center">
                                        <VarSpace>{{ $t('components.AIOrderTaskWindow.zsy') }}</VarSpace>
                                        <VarChip size="small" :type="(v.TotalAmount ?? 0) >= 0 ? 'success' : 'danger'">
                                            <VarCountTo :duration="300" :to="v.TotalAmount ?? 0" :precision="8" />
                                        </VarChip>
                                    </VarSpace>

                                    <VarSpace align="center">
                                        <VarSpace>{{ $t('components.AIOrderTaskWindow.rws') }}</VarSpace>
                                        <VarChip size="small" type="primary">
                                            {{ v.TotalTaskCount ?? 0 }}
                                        </VarChip>
                                    </VarSpace>

                                </VarSpace>

                                <VarSpace align="center">
                                    <template v-if="aiOrderStore.effectStatusArr[aiOrderStore.active] == 'finish'">
                                        <span>{{ $t('components.AIOrderTaskWindow.startTime') }}</span>
                                        <span>{{ (v.StartTime && Tools.ConvertTimestamp(v.StartTime ?? 0)) || '--'
                                        }}</span>

                                        <span>{{ $t('components.AIOrderTaskWindow.overTime') }}</span>
                                        <span>{{ (v.OverTime && Tools.ConvertTimestamp(v.OverTime ?? 0)) || '--'
                                        }}</span>
                                    </template>
                                    <template v-else>
                                        <span>{{ $t('components.AIOrderTaskWindow.yxsj') }}</span>
                                        <span>{{ aiOrderStore.GetRunTime(v) }}</span>
                                    </template>
                                </VarSpace>

                            </VarSpace>

                            <!-- 分页 -->
                            <div class="ai-order-pagination">
                                <var-pagination :show-size-changer="false" v-model:current="aiOrderStore.data.page"
                                    v-model:size="aiOrderStore.data.pageSize" :total="aiOrderStore.data.total" />
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <EmptyComponent style="width: 100%;"></EmptyComponent>
                    </template>

                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <VarOverlay v-model:show="aiOrderStore.show">
            <VarCard :title="$t('components.AIOrderTaskWindow.title')">
                <var-tabs v-model:active="aiOrderStore.active">
                    <var-tab v-for="v in aiOrderStore.effectStatusArr">{{ $t(`components.AIOrderTaskWindow.${v}`)
                    }}</var-tab>
                </var-tabs>
                <template v-if="aiOrderStore.data.total > 0">
                    <var-table full-width="80%" scroller-height="50%">
                        <thead style="position: sticky; top: 0">
                            <tr style="white-space: nowrap;">
                                <th>{{ $t('components.AIOrderTaskWindow.rwd') }}</th>
                                <th>{{ $t('components.AIOrderTaskWindow.cp') }}</th>
                                <th>{{ $t('components.AIOrderTaskWindow.gmfy') }}</th>
                                <th>{{ $t('components.AIOrderTaskWindow.zsy') }}</th>
                                <th>{{ $t('components.AIOrderTaskWindow.rws') }}</th>
                                <template v-if="aiOrderStore.effectStatusArr[aiOrderStore.active] == 'finish'">
                                    <th>{{ $t('components.AIOrderTaskWindow.startTime') }}</th>
                                    <th>{{ $t('components.AIOrderTaskWindow.overTime') }}</th>
                                </template>
                                <template v-else>
                                    <th>{{ $t('components.AIOrderTaskWindow.yxsj') }}</th>
                                </template>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(v, i) in aiOrderStore.data.list" :key="v.Id">
                                <td>
                                    <VarEllipsis style="max-width: 150px;">{{ v.OrderNumber }}</VarEllipsis>
                                </td>
                                <td>
                                    <VarEllipsis style="max-width: 150px;">{{ v.Product.Dn }}</VarEllipsis>
                                </td>
                                <td>
                                    <VarChip size="small" type="info">
                                        <div style="white-space:nowrap;">
                                            $ {{ Tools.TruncateDecimal(v.BuyCost ?? 0, 2) }}
                                        </div>
                                    </VarChip>
                                </td>
                                <td>
                                    <VarChip size="small" :type="(v.TotalAmount ?? 0) >= 0 ? 'success' : 'danger'">
                                        <div
                                            style="min-width: 100px; justify-content: center; max-width: 200px; display: flex; flex-wrap: nowrap; align-items: center;">
                                            <span>$&nbsp;</span>
                                            <VarCountTo :duration="300" :to="v.TotalAmount ?? 0" :precision="8" />
                                        </div>
                                    </VarChip>

                                </td>
                                <td>
                                    <VarChip size="small" type='primary'>
                                        {{ v.TotalTaskCount ?? 0 }}
                                    </VarChip>
                                </td>
                                <template v-if="aiOrderStore.effectStatusArr[aiOrderStore.active] == 'finish'">
                                    <td>{{ (v.StartTime && Tools.ConvertTimestamp(v.StartTime ?? 0)) || '--' }}</td>
                                    <td>{{ (v.OverTime && Tools.ConvertTimestamp(v.OverTime ?? 0)) || '--' }}</td>
                                </template>
                                <template v-else>
                                    <td>{{ aiOrderStore.GetRunTime(v) }}</td>
                                </template>
                            </tr>
                        </tbody>

                        <template #footer>
                            <div class="table-example-footer">
                                <var-pagination :show-size-changer="false" :simple="false"
                                    v-model:current="aiOrderStore.data.page" v-model:size="aiOrderStore.data.pageSize"
                                    :total="aiOrderStore.data.total" />
                            </div>
                        </template>
                    </var-table>
                </template>
                <template v-else>
                    <EmptyComponent style="width: 80vw; height: 50vh;"></EmptyComponent>
                </template>
            </VarCard>

        </VarOverlay>
    </template>

</template>

<script lang="tsx" setup>
import { useAiOrderStore } from '@/store/AiOrderTaskStore';
import Tools from '@/utils/Tools';
import { inject, ref, watch } from 'vue';
import EmptyComponent from '../GlobalComponents/EmptyComponent.vue';
import SignalRService from '@/typescript/Services/SignalRService';
import CloseFabButtonComponent from '../GlobalComponents/CloseFabButtonComponent.vue';
const aiOrderStore = useAiOrderStore();
const IsMobile = inject<boolean>("IsMobile");

watch([() => aiOrderStore.show, () => aiOrderStore.active, () => aiOrderStore.data.page], (_n, _o) => {
    if (_n[0]) {
        aiOrderStore.LoadDataAsync();
    }
}, {
    immediate: true
});


</script>

<style lang="scss" scoped>
.table-example-footer {
    padding: 10px 0px !important;
}

.phone-body {
    display: flex;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 1000;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.pc-card {
    display: flex;
    max-height: 100%;
    height: 100%;
    width: 100%;
    background-color: var(--color-body);
    font-size: 12px;
    overflow: hidden;

    .pc-ai-order-body {
        display: flex;
        overflow: hidden;
        height: 100%;
        width: 100%;
        position: relative;
        flex-direction: column;


        .pc-ai-order-list {
            display: flex;
            flex-direction: column;
            width: 100%;
            min-width: 100%;
            flex-wrap: 1;
            overflow-y: auto;
            padding: 0px 10px;

            box-sizing: border-box;

            &::-webkit-scrollbar {
                width: 0px;
                height: 0px;
            }

            .ai-order-pagination {
                position: sticky;
                bottom: 0px;
                background-color: var(--tabs-background);
                height: 50px;
                min-height: 50px;
            }
        }
    }
}
</style>